/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { Settings } from '../../../core/device/Settings';
import { ScreenPreviewProps } from './ScreenPreviewProps';

import './ScreenPreview.scss';

const ScreenPreview: FunctionComponent<ScreenPreviewProps> = ({
    children,
    classStyle,
}): JSX.Element => {
    const settingsService = new Settings();
    const isVideoWindowEnabled = settingsService.isVideoWindowEnabled();
    return (
        <div
            className={`preview-container${!isVideoWindowEnabled ? ' without-video-window' : ''} ${classStyle || ''}`}
        >
            {children}
        </div>
    );
};

export default ScreenPreview;
